/* eslint-disable react/jsx-key */
import { makeStyles } from '@material-ui/core';
import DropdownInput from 'components/Dropdown/Dropdown';
import ChargesTabContent from 'components/InvestmentAnalyser/ChargesTabContent';
import OverviewTabContent from 'components/InvestmentAnalyser/OverviewTabContent';
import PerformanceTabContent from 'components/InvestmentAnalyser/PerformanceTabContent';
import RiskTabContent from 'components/InvestmentAnalyser/RiskTabContent';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux-starter-kit';
import Store from 'store/store';
import actions from 'store/actions';
import api from 'api';

const { selectors } = Store;

interface Props {
  provider: any;
  updateResearchInvestments: any;
}

const Portfolios = ({ provider, updateResearchInvestments }: Props) => {
  const useStyles = makeStyles((theme: any) => {
    return {
      tab: {
        background: '#eeeeee',
        padding: '15px 25px',
        borderRadius: '25px',
        cursor: 'pointer',
        width: '100%',
        textAlign: 'center',
        fontWeight: 700
      },
      activeTab: {
        background: theme.palette.secondary.main,
        color: '#FFFFFF'
      }
    };
  });
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState('Overview');
  const [factsheetRange, setFactsheetRange] = useState() as any;

  const handleTabClick = (tab: any) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const range =
      provider.portfolio_ranges[
        factsheetRange
          ? provider.portfolio_ranges.findIndex(
              (range: any) => range.id == factsheetRange
            )
          : 0
      ].id;

    setFactsheetRange(range);

    if (range) {
      api.getMpsHubRiskPortfolioResearch(provider, range).then(({ data }) => {
        updateResearchInvestments(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factsheetRange]);

  const tabComponents: any = {
    Overview: OverviewTabContent,
    Charges: ChargesTabContent,
    Performance: PerformanceTabContent,
    Risk: RiskTabContent
  };

  const TabComponent = tabComponents[activeTab];

  return (
    <div style={{ padding: '1rem' }}>
      <DropdownInput
        options={provider.portfolio_ranges}
        label={'Select Portfolio Range'}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange={(e: any) => {
          setFactsheetRange(e.id);
        }}
        objectKey={'name_with_categories'}
        search={true}
        value={provider.portfolio_ranges[0].name_with_categories}
      />
      <div style={{ padding: '1rem', height: '100%' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            gap: '15px'
          }}
        >
          {Object.keys(tabComponents).map(tab => (
            <div
              key={tab}
              className={`${classes.tab} ${
                activeTab === tab ? classes.activeTab : ''
              }`}
              onClick={() => handleTabClick(tab)}
            >
              {tab}
            </div>
          ))}
        </div>
        <TabComponent
          selectedInvestment={undefined}
          provider={provider}
          range={factsheetRange}
        />
      </div>
    </div>
  );
};

export default compose(
  connect(
    (state: any) => ({
      investments:
        selectors.investmentAnalyserSelectors.researchInvestments(state)
    }),
    {
      updateResearchInvestments:
        actions.investmentAnalyserActions.updateResearchInvestments
    }
  )
)(Portfolios);
